import React from "react";
import { Button, ButtonDropdown, Icon, ToolTips } from "@px/px_design_system";

function DataExporterButton({
  buttonLabels,
  id,
  isBusy,
  isDisabled,
  onButtonClick,
  tooltipText,
}) {
  const handleExportButtonClick = ({ target }) => {
    const buttonText = target?.innerText || target?.textContent;
    onButtonClick?.(buttonText);
  };

  const icon = (
    <Icon
      icon={["fas", `${isBusy ? "spinner" : "arrow-down"}`]}
      size="1x"
      data-testid="export-icon"
    />
  );

  const className = `paginated-csv__btn${
    isBusy ? "--in-progress disabled" : ""
  }`;
  const [primaryLabel, ...restLabels] = buttonLabels;

  return (
    <ToolTips disabled={isDisabled} text={tooltipText} id={id}>
      {restLabels?.length > 0 ? (
        <ButtonDropdown
          bgColor="secondary"
          id="caret"
          className={className}
          icon={icon}
          isDisabled={isBusy || isDisabled}
          dropdownItems={restLabels}
          iconType={[icon]}
          primaryText={primaryLabel}
          handleClick={handleExportButtonClick}
          size="5x"
        />
      ) : (
        <Button
          id={id}
          className={className}
          buttontext={primaryLabel}
          disabled={isBusy || isDisabled}
          justified
          onClick={handleExportButtonClick}
          icon={icon}
        />
      )}
    </ToolTips>
  );
}

export default DataExporterButton;
